export const isDevEnv = process.env.REACT_APP_CUSTOM_NODE_ENV !== 'production';
